import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { receiveRoute } from '@m/cabinet/components/views/utils'
import Receive from '@m/cabinet/components/views/Receive.vue'
import {
  COORDINATOR_TAB_KEY,
  DOCUMENTS_TAB_KEY,
  GENERAL_TAB_KEY,
  REQUISITES_TAB_KEY,
} from '@/modules/cabinet/modules/Facility/const'
import { branchModerationApi } from '@/services/branchModeration.service'
import { facilityAdminDetailResource } from '@/services/facility.service'

export const STAFF_FACILITIES_VIEW_NAME = 'staff:facilities'

const MODERATION_FACILITIES_PREFIX = `${STAFF_FACILITIES_VIEW_NAME}:moderation`
const FACILITIES_PREFIX = `${STAFF_FACILITIES_VIEW_NAME}:facilities`
// export const SETTINGS_BASE = 'cabinet:settings'
// export const NOTIFICATIONS_BASE = 'cabinet:notifications'
// export const STAFF_NOTIFICATIONS_BASE = 'cabinet:notifications'
const mFPrefix = (name: string) => MODERATION_FACILITIES_PREFIX + ':' + name
const fPrefix = (name: string) => FACILITIES_PREFIX + ':' + name
// const s = (name: string) => SETTINGS_BASE + ':' + name
// const n = (name: string) => NOTIFICATIONS_BASE + ':' + name

export const FACILITIES_MODERATION_VIEW_NAME = mFPrefix('list')
export const FACILITY_MODERATION_VIEW_NAME = mFPrefix('view')
export const FACILITY_MODERATION_GENERAL_VIEW_NAME = mFPrefix(GENERAL_TAB_KEY)
export const FACILITY_MODERATION_DOCUMENTS_VIEW_NAME =
  mFPrefix(DOCUMENTS_TAB_KEY)
export const FACILITY_MODERATION_LICENCE_VIEW_NAME = mFPrefix('licence')
export const FACILITY_MODERATION_COORDINATOR_VIEW_NAME =
  mFPrefix(COORDINATOR_TAB_KEY)
export const FACILITY_MODERATION_REQUISITES_VIEW_NAME =
  mFPrefix(REQUISITES_TAB_KEY)
export const FACILITY_MODERATION_HISTORY_VIEW_NAME = mFPrefix('history')

const FacilitiesModerationListView = () => import('./ModerationFacilities/List.vue')
const FacilityView = () => import('./ModerationFacilities/View.vue')
const FacilityGeneral = () =>
  import('./ModerationFacilities/tabs/General.vue')
const FacilityLicence = () =>
  import('./ModerationFacilities/tabs/Licence.vue')
const FacilityDocuments = () =>
  import('./ModerationFacilities/tabs/Documents.vue')
const FacilityRequisites = () =>
  import('./ModerationFacilities/tabs/Requisites.vue')
const FacilityCoordinators = () =>
  import('./ModerationFacilities/tabs/Coordinators.vue')
const FacilityHistory = () =>
  import('./ModerationFacilities/tabs/History.vue')


export const FACILITIES_STAFF_VIEW_NAME = fPrefix('list')
export const FACILITY_STAFF_VIEW_NAME = fPrefix('view')
export const FACILITY_STAFF_GENERAL_VIEW_NAME = fPrefix(GENERAL_TAB_KEY)
export const FACILITY_STAFF_DOCUMENTS_VIEW_NAME =
  fPrefix(DOCUMENTS_TAB_KEY)
export const FACILITY_STAFF_LICENCE_VIEW_NAME = fPrefix('licence')
export const FACILITY_STAFF_COORDINATOR_VIEW_NAME =
  fPrefix(COORDINATOR_TAB_KEY)
export const FACILITY_STAFF_REQUISITES_VIEW_NAME =
  fPrefix(REQUISITES_TAB_KEY)

const FacilitiesStaffListView = () => import('./Facilities/List.vue')
const FacilityStaffView = () => import('./Facilities/View.vue')
const FacilityStaffGeneral = () =>
  import('./Facilities/tabs/General.vue')
const FacilityStaffLicence = () =>
  import('./Facilities/tabs/Licence.vue')
const FacilityStaffDocuments = () =>
  import('./Facilities/tabs/Documents.vue')
const FacilityStaffRequisites = () =>
  import('./Facilities/tabs/Requisites.vue')
const FacilityStaffCoordinators = () =>
  import('./Facilities/tabs/Coordinators.vue')


export const FACILITIES_MODEL_PATH = 'facilities/'

// const BASE_SETTINGS_MODEL_PATH = 'settings/'
// const BASE_NOTIFICATIONS_MODEL_PATH = 'notifications/'

export function createFacilitiesRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    prefixRoutes(
      'moderation/',
      [
        route('list/', FacilitiesModerationListView, FACILITIES_MODERATION_VIEW_NAME, {
          meta: {
            title: () => $t('Requests for moderation of medical facilities'),
          },
        }),

        prefixRoutes(
          '',
          [
            {
              name: FACILITY_MODERATION_VIEW_NAME,
              redirect: { name: FACILITY_MODERATION_GENERAL_VIEW_NAME },
              ...(receiveRoute(
                branchModerationApi.detail,
                [
                  prefixRoutes(
                    '',
                    [
                      route(
                        'general/',
                        FacilityGeneral,
                        FACILITY_MODERATION_GENERAL_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_MODERATION_VIEW_NAME,
                              text: $t('Back to all requests'),
                            },
                          },
                        }
                      ),

                      route(
                        'licence/',
                        FacilityLicence,
                        FACILITY_MODERATION_LICENCE_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_MODERATION_VIEW_NAME,
                              text: $t('Back to all requests'),
                            },
                          },
                        }
                      ),
                      route(
                        'requisites/',
                        FacilityRequisites,
                        FACILITY_MODERATION_REQUISITES_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_MODERATION_VIEW_NAME,
                              text: $t('Back to all requests'),
                            },
                          },
                        }
                      ),
                      route(
                        'coordinator/',
                        FacilityCoordinators,
                        FACILITY_MODERATION_COORDINATOR_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_MODERATION_VIEW_NAME,
                              text: $t('Back to all requests'),
                            },
                          },
                        }
                      ),
                      route(
                        'history/',
                        FacilityHistory,
                        FACILITY_MODERATION_HISTORY_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_MODERATION_VIEW_NAME,
                              text: $t('Back to all requests'),
                            },
                          },
                        }
                      ),
                      route(
                        'documents/',
                        FacilityDocuments,
                        FACILITY_MODERATION_DOCUMENTS_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_MODERATION_VIEW_NAME,
                              text: $t('Back to all requests'),
                            },
                          },
                        }
                      ),
                    ],
                    {
                      name: FACILITY_MODERATION_VIEW_NAME,
                      redirect: { name: FACILITY_MODERATION_GENERAL_VIEW_NAME },
                      meta: {},
                      component: FacilityView,
                      props: {
                        resource: branchModerationApi.detail,
                        resourceKey: 'id',
                        routeKey: 'facility',
                      },
                    }
                  ),
                ],
                Receive,
                '',
                'facility',
                'id',
                {
                  isHideCabinetHead: true,
                }
              ) as any),
            },
          ],
          {
            ...options,
          }
        ),
      ],
      options
    ),

    prefixRoutes(
      'facilities/',
      [
        route('list/', FacilitiesStaffListView, FACILITIES_STAFF_VIEW_NAME, {
          meta: {
            title: () => $t('Medical facilities'),
          },
        }),

        prefixRoutes(
          '',
          [
            {
              name: FACILITY_STAFF_VIEW_NAME,
              redirect: { name: FACILITY_STAFF_GENERAL_VIEW_NAME },
              ...(receiveRoute(
                facilityAdminDetailResource,
                [
                  prefixRoutes(
                    '',
                    [
                      route(
                        'general/',
                        FacilityStaffGeneral,
                        FACILITY_STAFF_GENERAL_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_STAFF_VIEW_NAME,
                              text: $t('All medical facilities'),
                            },
                          },
                        }
                      ),

                      route(
                        'licence/',
                        FacilityStaffLicence,
                        FACILITY_STAFF_LICENCE_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_STAFF_VIEW_NAME,
                              text: $t('All medical facilities'),
                            },
                          },
                        }
                      ),
                      route(
                        'requisites/',
                        FacilityStaffRequisites,
                        FACILITY_STAFF_REQUISITES_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_STAFF_VIEW_NAME,
                              text: $t('All medical facilities'),
                            },
                          },
                        }
                      ),
                      route(
                        'coordinator/',
                        FacilityStaffCoordinators,
                        FACILITY_STAFF_COORDINATOR_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_STAFF_VIEW_NAME,
                              text: $t('All medical facilities'),
                            },
                          },
                        }
                      ),
                      route(
                        'documents/',
                        FacilityStaffDocuments,
                        FACILITY_STAFF_DOCUMENTS_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Medical facility'),
                            isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: FACILITIES_STAFF_VIEW_NAME,
                              text: $t('All medical facilities'),
                            },
                          },
                        }
                      ),
                    ],
                    {
                      name: FACILITY_STAFF_VIEW_NAME,
                      redirect: { name: FACILITY_STAFF_GENERAL_VIEW_NAME },
                      meta: {},
                      component: FacilityStaffView,
                      props: {
                        resource: facilityAdminDetailResource,
                        resourceKey: 'id',
                        routeKey: 'facility',
                      },
                    }
                  ),
                ],
                Receive,
                '',
                'facility',
                'id',
                {
                  isHideCabinetHead: true,
                }
              ) as any),
            },
          ],
          {
            ...options,
          }
        ),
      ],
      options
    ),
    {
      path: '', 
      redirect: { name: FACILITIES_STAFF_VIEW_NAME },
    },
  ]
}

// export function createNotificationsRoutes(options: Options): RouteRecordRaw[] {
//   const { t: $t } = i18n.global
//   const { app } = options
//   app.config.globalProperties.$router_notifications_view_name =
//     NOTIFICATIONS_VIEW_NAME

//   return [
//     route('', NotificationsView, NOTIFICATIONS_VIEW_NAME, {
//       meta: {
//         title: () => $t('My notifications'),
//       },
//     }),
//   ]
// }
// export function createSettingsRoutes(options: Options): RouteRecordRaw[] {
//   const { t: $t } = i18n.global
//   const { app } = options
//   app.config.globalProperties.$router_notifications_settings_telegram_view_name =
//     NOTIFICATIONS_SETTINGS_TELEGRAM_VIEW_NAME
//   return [
//     route('security/', SecurityView, SECURITY_VIEW_NAME, {
//       meta: {
//         title: () => $t('Security'),
//         ...accessPermission([IS_ADMINISTRATOR], options),
//       },
//     }),
//     route(
//       'notifications/',
//       NotificationsSettingsView,
//       NOTIFICATIONS_SETTINGS_VIEW_NAME,
//       {
//         meta: {
//           title: () => $t('Setting up notifications'),
//         },
//       }
//     ),
//     route(
//       'telegram-subscription/',
//       NotificationTelegramSubscriptionView,
//       NOTIFICATIONS_SETTINGS_TELEGRAM_VIEW_NAME,
//       {
//         meta: {
//           title: () => $t('Telegram bot subscription'),
//         },
//       }
//     ),
//   ]
// }
